// @flow
import React, { useState } from 'react';
import { useViewport } from 'components/templates/viewportProvider';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import './styles.scss';
import { FloorPlan } from 'components/molecules/floorPlan';
import Dotdotdot from 'react-dotdotdot';
import { Image } from 'components/atoms/image';

export const HotspotOverlay = props => {
  const {
    data: { version, clickedHotspotValue },
  } = props;
  const { height } = useViewport();

  const [hotspotInfo, setHotspotInfo] = useState(clickedHotspotValue);

  const hotspotChanged = value => {
    setHotspotInfo(value);
  };

  return (
    <div className={'floorplan-overlay-container'} style={{ height }}>
      <div className={'floorplan-overlay-image-container'}>
        <FloorPlan
          version={version}
          callingFromHotspot={true}
          onHotspotChange={hotspotChanged}
        />
      </div>
      <div className={'hotspot-info-container'}>
        <div className={'hotspot-info-image '}>
          {/*<img key={hotspotInfo.id} src={hotspotInfo.desktopImage} alt="" />*/}
          <Image
            src={hotspotInfo.desktopImage}
            alt={'hotspot failed'}
            thumbNail={hotspotInfo.thumbNailUrl}
            isHoveredImagePresent={true}
            keyChange={hotspotInfo.id}
            objectFit={'cover'}
          />
        </div>
        <div className={'hotspot-info-box'}>
          <div className={'hotspot-name-desc-box'}>
            <h2>{hotspotInfo.heading}</h2>
            <Dotdotdot clamp={4} tagName={'p'}>
              {hotspotInfo.description}
            </Dotdotdot>
          </div>
          <div className={'hotspot-area-box'}>
            {hotspotInfo.outdoorSpaces && (
              <>
                <span>OUTDOOR SPACES</span>
                <h2>{hotspotInfo.outdoorSpaces}</h2>
                <p>&nbsp;&nbsp;{hotspotInfo.outdoorParameter}</p>
                <br />
              </>
            )}
            {hotspotInfo.indoorSpaces && (
              <>
                <span>INDOOR SPACES</span>
                <h2>{hotspotInfo.indoorSpaces}</h2>
                <p>&nbsp;&nbsp;{hotspotInfo.indoorParameter}</p>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
